<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AppNavbar from '@/components/AppNavbar.vue';
import AppSidebar from '@/components/AppSidebar.vue';
import ToastStack from '@/components/ToastStack.vue';
import LoadingBar from '@/components/LoadingBar.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';
import ChatPanel from '@/components/chat/ChatPanel.vue';
import { useUiStore } from '@/stores/ui';
import { useAuthStore } from '@/stores/auth';

const route = useRoute();
const ui = useUiStore();
const auth = useAuthStore();
const blank = computed(() => route.meta.layout === 'blank' || !auth.isAuthenticated);
</script>

<template>
  <LoadingBar />
  <a href="#main-content" class="skip-link">Ga naar hoofdinhoud</a>
  <template v-if="blank">
    <router-view />
  </template>
  <template v-else>
    <AppNavbar />
    <div class="kl-shell" :style="{ '--kl-chat-width': `${ui.chatWidth}px` }">
      <AppSidebar v-if="auth.isActive" />
      <main
        id="main-content"
        class="kl-main"
        :class="{
          'sidebar-collapsed': ui.sidebarCollapsed || !auth.isActive,
          'chat-open': ui.chatOpen && auth.isActive,
        }"
      >
        <router-view />
      </main>
      <ChatPanel v-if="auth.isActive && ui.chatOpen" />
    </div>
  </template>
  <ToastStack />
  <ConfirmModal />
</template>
